var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/user"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 20,
    height: 20,
    rx: 10,
    stroke: "#FAFAFA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.25 18.25V16.75C16.25 15.9544 15.9339 15.1913 15.3713 14.6287C14.8087 14.0661 14.0456 13.75 13.25 13.75H8.75C7.95435 13.75 7.19129 14.0661 6.62868 14.6287C6.06607 15.1913 5.75 15.9544 5.75 16.75V18.25",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 10.75C12.6569 10.75 14 9.40685 14 7.75C14 6.09315 12.6569 4.75 11 4.75C9.34315 4.75 8 6.09315 8 7.75C8 9.40685 9.34315 10.75 11 10.75Z",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3e061158327fb9417e5dca662f680880.svg";
export { ForwardRef as ReactComponent };